import type { TimePeriod } from './bookings'
import type { HuntType } from './hunt-type'
import type { TimeBlock } from './time-block'

export const TIME_PERIOD_RESELECT_MESSAGE =
  'This location uses different time blocks. Select a time again.'

const PLATFORM_DEFAULT_BLOCK = 'platform-default'

function offeredBlockFor(
  blocks: TimeBlock[],
  huntType: HuntType,
  timePeriod: TimePeriod,
): string | null {
  const configured = blocks.filter((block) => block.huntType === huntType)
  if (configured.length === 0) return PLATFORM_DEFAULT_BLOCK
  const match = configured.find((block) => block.timePeriod === timePeriod)
  if (!match) return null
  return `${match.name}|${match.startTime}|${match.endTime}`
}

export type TimePeriodNeedsReselectParams = {
  previous: TimeBlock[]
  next: TimeBlock[]
  huntType: HuntType
  timePeriod: TimePeriod | undefined
}

export function timePeriodNeedsReselect(
  params: TimePeriodNeedsReselectParams,
): boolean {
  const { previous, next, huntType, timePeriod } = params
  if (!timePeriod) return false
  return (
    offeredBlockFor(previous, huntType, timePeriod) !==
    offeredBlockFor(next, huntType, timePeriod)
  )
}
